import { type FC } from 'react'
import { UpsellBodyLayout } from '../../Common/UpsellBodyLayout'
import { UpsellFeatureItem } from '../../Common/UpsellFeatureItem'
import SchedulingPromo from '../../../../assets/images/upsell-scheduling.png'

export const SchedulingUpsellBody: FC = () => {
  return (
    <UpsellBodyLayout
      image={<img src={SchedulingPromo} alt='Scheduling promo' className='zocks-border-0.5 w-100 object-fit-contain' />}
      heading={
        <>
          Let clients book with <span className='zocks-text-primary'>Scheduling</span>
        </>
      }
      description='Share a booking page and clients pick a time that works. Every booking connects to a Meeting type, so your AI Assistant is ready to take notes.'
    />
  )
}

export const SchedulingUpsellFeatures: FC = () => {
  return (
    <>
      <UpsellFeatureItem title='Get booked faster' description='Clients pick a time from your booking page, with no email back and forth' />
      <UpsellFeatureItem title='Save hours every week' description='Confirmations and reminders go out automatically' />
      <UpsellFeatureItem title='Stay ready to take notes' description='Every booking links to a Meeting type so your AI Assistant is ready' className='mb-3' />
    </>
  )
}
